import { ArrowRight, Plus } from "lucide-react";
import { categoryTitle } from "@/data/site";
import { useMachines } from "@/components/machines/MachineProvider";
import { cn } from "@/lib/utils";
import { Tilt } from "@/components/fx/Motion";

export const MachineCard = ({ m, className }) => {
  const { openDetails, openRequest } = useMachines();
  return (
    <Tilt max={5} className={cn("h-full", className)}>
    <article className={cn("group flex h-full flex-col overflow-hidden rounded-[24px] border border-white/5 bg-ink-800 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-volt/40")} data-testid={`machine-card-${m.id}`}>
      <div className="relative m-2 h-[clamp(220px,34vh,340px)] overflow-hidden rounded-[18px]">
        <img src={m.img} alt={m.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.07]" />
        <div className="scanlines pointer-events-none absolute inset-0 opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-950/70 to-transparent" />
        <span className="absolute left-4 top-4 rounded-full bg-ink-950/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-volt backdrop-blur-md" data-testid={`machine-category-${m.id}`}>
          {categoryTitle(m.category)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6 pt-4">
        <h3 className="font-display text-2xl font-semibold tracking-tight text-white" data-testid={`machine-name-${m.id}`}>{m.name}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-400">{m.desc}</p>
        <div className="mt-6 flex items-center gap-3">
          <button onClick={() => openRequest(m)} className="btn-primary h-11 flex-1 px-4 text-sm" data-testid={`request-machine-${m.id}`}>
            Request This Machine <ArrowRight className="btn-arrow h-4 w-4" />
          </button>
          <button onClick={() => openDetails(m)} className="btn-ghost h-11 px-4 text-sm" data-testid={`learn-more-${m.id}`}>
            <Plus className="h-4 w-4" /> Learn More
          </button>
        </div>
      </div>
    </article>
    </Tilt>
  );
};
